<script>
export default {
  name: "Footer",
  data() {
    return {
      latitud: 0,
      longitud: 0,
      temperatura: 0,
      indiceUv: 0,
      icono: "",
      classUv: "",
      nameUv: ""
    };
  },
  methods: {
    getGeolocalization() {
      if ("geolocation" in navigator) {
        navigator.geolocation.getCurrentPosition((position) => {
          this.latitud = position.coords.latitude;
          this.longitud = position.coords.longitude;
          this.getWeather();
        });
      } else {
        this.temperatura = '-';
        this.indiceUv = '-';
        this.classUv = "gray";
        this.nameUv = '-';
      }
    },
    getWeather() {
      fetch(
        `https://api.weatherapi.com/v1/forecast.json?key=${process.env.VUE_APP_WEATHER_KEY}&q=${this.latitud},${this.longitud}&days=7&aqi=no&alerts=no`
      )
        .then((respuesta) => {
          return respuesta.json();
        })
        .then((datosClima) => {
          console.log(datosClima)
          this.temperatura = datosClima.current.temp_c;
          this.indiceUv = datosClima.current.uv;
          this.icono = datosClima.current.condition.icon;
          if (this.indiceUv >= 0 && this.indiceUv <= 2.9) {
            this.classUv = "green-2";
            this.nameUv = 'Bajo';
          } else if (this.indiceUv >= 3 && this.indiceUv <= 5.9) {
            this.classUv = "yellow";
            this.nameUv = 'Moderado';
          } else if (this.indiceUv >= 6 && this.indiceUv <= 7.9) {
            this.classUv = "orange";
            this.nameUv = 'Alto';
          } else if (this.indiceUv >= 8 && this.indiceUv <= 10.9) {
            this.classUv = "red";
            this.nameUv = 'Muy Alto';
          } else if (this.indiceUv >= 11) {
            this.classUv = "purple";
            this.nameUv = 'Extremo';
          } else {
            this.classUv = "gray";
            this.nameUv = '-';
          }
        });
    },
  },
  mounted() {
    this.getGeolocalization();
  },
};
</script>

<template>
  <footer class="footer">
    <div class="d-flex justify-content-center">
      <div div class="col-12 col-md-6 col-xl-5 col-xxl-4">
        <div
          class="d-flex align-items-center justify-content-center rounded-5 p-2 text-light bg-main"
        >
          <span>Índice UV</span>
          <span
            :class='`badge rounded-circle border border-2 border-light bg-${classUv} mx-2 circle-uv`'
            >{{ parseInt(indiceUv) }}</span
          >
          {{nameUv}}
          <span class="mx-4">•</span>
          <span>T {{parseInt(temperatura)}}°C</span>
          <span v-show="icono !== ''"> <img :src="icono" class="img-weather" alt="Clima"> </span>
        </div>
        <div class="d-flex align-items-center justify-content-center mt-3">
          <p class="text-secondary">
            Creado con
            <font-awesome-icon
              icon="fa-solid fa-heart"
              class="color-red px-1"
            ></font-awesome-icon>
            por <strong> CARPETRES</strong>
          </p>
        </div>
      </div>
    </div>
  </footer>
</template>
